import { Box, useTheme } from "@mui/material"
import { useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { useAddCountingStrategyTemplateMutation } from "../../../newapi/countingstrategy/countingStrategyTemplateSlice";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import ShValidatedNumberInput from "../../theme/inputs/ShValidatedNumberInput";
import ShValidatedInputDropdown from "../../theme/dropdowns/ShValidatedInputDropdown";
import { yupRequired, yupDecimalRequired } from "../../../utils/validation";
import { useGetEnumsQuery } from "../../../newapi/global/generalApiSlice";
import EMCountingStrategyAmount from "../ModalsPopover/explainers/countingstrategy/EMCountingStrategyAmount";


const MAddCountingStrategy = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [addCountingStrategy,{isLoading}] = useAddCountingStrategyTemplateMutation();

    const [strategyInfo, setStrategyInfo] = useState({
        name: "",
        type: "",
        frequency: "",
        amount: 0
    });

    const handleClose = () => {
      setStrategyInfo({
          name: "",
          type: "",
          frequency: "",
          amount: 0
      });
      props.handleClose();
  }

    const { data: globalEnums, enumIsLoading } = useGetEnumsQuery("counting_strategy_type,time_based_frequencies");
    // console.log("globalEnums",globalEnums);
    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        name: yupRequired('name', t),
        type: yupRequired('type', t),
        frequency: yupRequired('frequency', t),
        amount: yupDecimalRequired('amount', t)
    };
    
    const schema = yup.object().shape(rules);

    const SaveStrategyInfo = async (strategyInfo, props) => {
        try {
            if (isLoading) return;

            setFieldErrors({});
            await schema.validate(strategyInfo, { abortEarly: false });
            const data = await addCountingStrategy(strategyInfo).unwrap()
            showToastMessagePostRequest(t, data);

            handleClose();
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});
          
                // Set the validation errors in the state
                setFieldErrors(errors);
              } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("create_failed"), t, err);
              }
        }
    };
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleChange = (key, value) => {
        setStrategyInfo({
          ...strategyInfo,
          [key]: value
        });
        setFieldErrors({
            ...fieldErrors,
            [key]: ''
          });
      };

    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("add_counting_strategy")}</Subheading>
            </Box>

            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                

                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7,
                        alignItems:"flex-start"
                    }}
                >
                    
                    <Box
                        sx={{
                            minWidth:210,
                            pt:1,
                        }}
                    >
                        <Text>{t("name")}</Text>
                    </Box>
                    
                    
                    <ShValidatedInput
                            name="name"
                            value={strategyInfo.name}
                            onChange={handleChange}
                            error={fieldErrors.name}
                        />
                            
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7,
                        alignItems:"flex-start"
                    }}
                >
                    
                    <Box
                        sx={{
                            minWidth:210,
                            pt:1,
                        }}
                    >
                        <Text>{t("frequency")}</Text>
                    </Box>
                    
                    
                    <ShValidatedInputDropdown
                        name="frequency"
                        displayName="displayName"
                        changeField="name"
                        selected={globalEnums ? globalEnums["time.based.frequencies"].findIndex(item => item === strategyInfo.frequency) ?? -1 : -1}
                        options={globalEnums ? globalEnums["time.based.frequencies"].map((item, index) => ({ id: index, name: item, displayName: t(item) })) : []}
                        noSelection={t("choose_option")} 
                        onChange={handleChange}
                        error={fieldErrors.frequency}
                    />
                            
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        justifyContent:"space-between",
                        gap:7,
                        alignItems:"flex-start"
                    }}
                >
                    
                    <Box
                        sx={{
                            minWidth:210,
                            pt:1,
                        }}
                    >
                        <Text>{t("type")}</Text>
                    </Box>
                    


                    
                    <ShValidatedInputDropdown
                        name="type"
                        displayName="displayName"
                        changeField="name"
                        options={globalEnums ? globalEnums["counting.strategy.type"].map((item, index) => ({ id: index, name: item, displayName: t(item) })) : []}
                        selected={globalEnums ? globalEnums["counting.strategy.type"].findIndex(item => item === strategyInfo.type) ?? -1 : -1}
                        noSelection={t("choose_option")} 
                        onChange={handleChange}
                        error={fieldErrors.type}
                    />
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        justifyContent:"space-between",
                        gap:7,
                        alignItems:"flex-start",
                    }}
                >
                    
                    <Box
                        sx={{
                            minWidth:210,
                            display: "flex",
                            alignItems: "center",
                            pt:1,
                        }}
                    >
                        <Text noBreak>... {t("_percent_of")} {strategyInfo.type.length > 0 ? t(`_${strategyInfo.type}`) : ""}</Text>
                        <EMCountingStrategyAmount></EMCountingStrategyAmount>
                    </Box>
                    
                    
                    <ShValidatedNumberInput
                        btnSize={"32"}
                        name="amount"
                        value={strategyInfo.amount}
                        onChange={handleChange}
                        error={fieldErrors.amount}
                    />
                        
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveStrategyInfo(strategyInfo, props)}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MAddCountingStrategy;
